/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { SmallText } from '../presentation/Text'
import FlexGrid from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'

export const IconsMenuItem = ({ active, icon, label, onClick, to }) => (
  <Link to={to} onClick={onClick}>
    <FlexGrid direction="column">
      <Icon name={icon} color={active ? COLORS.darkPruple : COLORS.dark3} />
      <SmallText weight={active && '800'} size="xsmall" align="center">
        {label}
      </SmallText>
    </FlexGrid>
  </Link>
)

const IconsMenu = ({ children }) => {
  const style = css`
    height: 3rem;

    & > .content {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0.4rem 1rem;
      box-shadow: ${COLORS.lightShadow1};
      background: ${COLORS.white};
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  `

  return (
    <div className="iconsMenu" css={style}>
      <div className="content" css={style}>
        {children}
      </div>
    </div>
  )
}

export default IconsMenu
